<template>
    <v-container>
        <div class="challengeProgress">
            <div class="challengeProgressNumber">{{start}}</div>
            <div class="challengeProgressBar">
                <div class="progressBackground"></div>
                <div 
                    class="progressBar" 
                    :style="progress >= 100 ? 'width: 100%' : 'width:' + progress + '%'"
                ></div>
                <div 
                    class="progressNumber"
                    :style="progress >= 100 ? 'left: 100%' : 'left:' + progress + '%'"
                >
                    {{ progress + '%' }}
                </div>
            </div>
            <div class="challengeProgressNumber2">{{end}}</div>
        </div>
    </v-container> 
</template>
<script>
export default {
    name: "ChallengeProgress",
    data(){
        return {
            start: undefined,
            end: undefined,
            progress: undefined
        }
    },
    computed: {
        challengeId(){
            return this.$store.getters.challengeId;
        }
    },
    methods: {
        getProgress(){
            // this.$axios.get('/challenges/' + this.challengeId + '/progress').then(response => {
            //     this.start = response.data.start;
            //     this.end = response.data.end;
            //     this.progress = Math.round(response.data.progress);
            // })
          this.start = '2022-08-12';
          this.end = '2023-09-12';
          this.progress = 40;
        }
    },
    mounted(){
        this.getProgress();
    },
    watch: {
        progress(value){
            if(value >= 100){
                document.querySelector('.challengeProgressNumber2').style.color = '#FFB5CC';
            }else{
                document.querySelector('.challengeProgressNumber2').style.color = '#ccc';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.challengeProgress{
    display: flex;
    align-items: center;
    color: #FFB5CC;

    .challengeProgressNumber{
        color: #FFB5CC;
        white-space: nowrap;
    }
    .challengeProgressNumber2{
        color: #ccc;
        white-space: nowrap;
    }
    .challengeProgressBar{
        width: 100%;
        height: 2px;
        margin: 0 8px;
        position: relative;

        .progressBackground{
            width :100%;
            height: 100%;
            background-color: #ccc;
            position: absolute;
        }
        .progressBar{
            width: 0;
            height: 100%;
            position: absolute;
            background-color: #FFB5CC;
            transition: all .4s;

            &::after{
                content: '';
                height: 8px;
                border-right: 2px solid #FFB5CC;
                position: absolute;
                top: -3px;
                right: 0;
            }
        }
        .progressNumber{
            position: absolute;
            top: -28px;
            left: 0;
            font-size: 14px;
            transform: translateX(-50%);
            transition: all .4s;
        }
    }
}
</style>